import { ROLES } from '@/constants/roles';

export default [
  {
    path: '/web-hooks',
    name: 'web_hook_list',
    component: () => import('@/views/pages/web-hooks/WebhookList.vue'),
    meta: {
      pageTitle: 'Webhooks',
      breadcrumb: {
        label: 'Webhooks'
      },
      roles: [ROLES.SUPERADMIN],
      verticalMenu: {
        title: 'Webhooks',
        icon: 'ZapIcon'
      }
    }
  },
  {
    path: '/web-hooks/create',
    name: 'create_web_hook',
    component: () => import('@/views/pages/web-hooks/CreateWebhook.vue'),
    meta: {
      pageTitle: 'Create Webhook',
      breadcrumb: {
        label: 'Create Webhook',
        parent: 'web_hook_list'
      },
      roles: [ROLES.SUPERADMIN]
    }
  },
  {
    path: '/web-hooks/:webhook_id',
    name: 'edit_web_hook',
    component: () => import('@/views/pages/web-hooks/EditWebhook.vue'),
    meta: {
      pageTitle: 'Edit Webhook',
      breadcrumb: {
        label: 'Edit Webhook',
        parent: 'web_hook_list'
      },
      roles: [ROLES.SUPERADMIN]
    }
  }
];
